import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {Router} from '@angular/router';
import {ClientServiceService} from '../client-service/client-service.service';

@Component({
  selector: 'app-package-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.css']
})
export class ClientFormComponent implements OnInit {
  clientDetailForm: FormGroup;
  clientTypeList: any = [];
  loading: boolean;
  submitted: boolean;
  constructor(private _formBuilder: FormBuilder,
              private router: Router,
              private clientService: ClientServiceService,
              private toastr: ToastrService) {
    this.clientDetailForm = this._formBuilder.group({
      id: [''],
      clientNumber: [''],
      clientType: ['', Validators.required],
      clientName: ['', Validators.required],
      addressLine1: ['', Validators.required],
      addressLine2: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      postalCode: ['', Validators.required],
      country: ['', Validators.required],
      primaryContact: this._formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        phoneNumberCell: ['', Validators.required],
        phoneNumberOffice: ['', Validators.required],
        email: ['', Validators.required],
        userType: 'HOSPITAL_PRIMARY_CONTACT',
        clientId: ['']
      }),
      comments: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.getAllClientTypes();
  }
  public saveClient(clientDetailForm: any) {
    this.loading = true;
    this.submitted = true;
    console.log(JSON.stringify(this.clientDetailForm.value));
    this.clientService.addUpdateClient(clientDetailForm.value)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Client saved successfully');
            this.router.navigate(['/elasticcare/client']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.toastr.error('', 'Please try again');
          this.loading = false;
        });
  }

  public getAllClientTypes() {
    this.clientTypeList = [{
      id : 'HOSPITAL',
      name: 'HOSPITAL'
    },
      {
        id : 'CLINIC',
        name: 'CLINIC'
      },
      {
        id : 'NURSING_HOME',
        name: 'NURSING_HOME'
      },
      {
        id : 'LONG_TERM_CARE',
        name: 'LONG_TERM_CARE'
      },
      {
        id : 'OTHERS',
        name: 'OTHERS'
      }];
  }
}
